import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Control, FieldErrors, useFieldArray, UseFormRegister, useWatch } from "react-hook-form";
import { ProgramInputs } from "../../schemas/inputs";
import { EvaluationType } from "../../schemas/types";
import { EvaluationSectionComponent } from "./EvaluationSectionComponent";

interface EvaluationStageSectionsProps {
    stageIndex: number;
    control: Control<ProgramInputs>;
    register: UseFormRegister<ProgramInputs>;
    errors: FieldErrors<ProgramInputs>;
    evaluationType: EvaluationType;
}

export const EvaluationStageSections = ({ stageIndex, control, register, errors, evaluationType }: EvaluationStageSectionsProps) => {
    const { fields, append, remove, update, insert } = useFieldArray({
        control,
        name: `evaluations.${stageIndex}.sections`
    });
    const sections = useWatch({
        control,
        name: `evaluations.${stageIndex}.sections`
    });

    const addSection = () => {
        append({
            name: '',
            criteria: []
        });
    };

    const cloneSection = (section: any) => {
        const { id, createdAt, updatedAt, order, isDeleted, ...copy } = section ?? {};
        return {
            ...copy,
            name: copy.name ? `${copy.name} (cópia)` : '',
            isDeleted: false,
            criteria: (copy.criteria ?? []).map((criterion: any) => {
                const {
                    id: criterionId,
                    createdAt: criterionCreatedAt,
                    updatedAt: criterionUpdatedAt,
                    order: criterionOrder,
                    isDeleted: criterionIsDeleted,
                    ...criterionCopy
                } = criterion ?? {};
                return { ...criterionCopy, isDeleted: false };
            })
        };
    };

    const deleteSection = (index: number) => {
        const currentSection = sections?.[index] ?? fields[index];
        if (currentSection?.id) {
            update(index, { ...currentSection, isDeleted: true });
            return;
        }

        remove(index);
    };

    const duplicateSection = (index: number) => {
        const currentSection = sections?.[index] ?? fields[index];
        insert(index + 1, cloneSection(currentSection));
    };

    return (
        <>
            {fields.map((field, sectionIndex) => {
                const currentSection = sections?.[sectionIndex] ?? field;
                if (currentSection?.isDeleted) return null;

                return (
                    <EvaluationSectionComponent
                        key={field.id}
                        stageIndex={stageIndex}
                        sectionIndex={sectionIndex}
                        control={control}
                        register={register}
                        errors={errors}
                        evaluationType={evaluationType}
                        onDelete={() => deleteSection(sectionIndex)}
                        onDuplicate={() => duplicateSection(sectionIndex)}
                    />
                );
            })}
            <Row className="mt-3">
                <Col>
                    <Button type="button" onClick={addSection} className="d-flex align-items-center gap-2 bg-transparent text-primary border border-dashed border-primary">
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                        Adicionar seção
                    </Button>
                </Col>
            </Row>
        </>
    );
};
